import { useEffect, useState } from 'react';

import { buildTree } from '@/pages/system/ops-center/service-catalog/utils';
import { GROUPS, PREFIX } from '@/service/apiConf';
import { get } from '@/service/request';

const url = () => `${PREFIX.oauths(GROUPS.ophub)}/nologin/available-product-catalogues`;

export const useProductMenu = () => {
  const [menus, setMenus] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    getMenu();
  }, []);

  const getMenu = async () => {
    try {
      const { orderMap, items } = (await get(url())) as any;
      setMenus(buildTree(items, JSON.parse(orderMap)));
      setData(items);
    } catch (error) {
      console.log('getMenu error', error);
    }
  };

  return { data, menus };
};
